import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const InstallationsPage = () => {
  const installations = [
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/c8c2263c-e1d0-489b-b2e3-3c72d5d2947f/NYC+Arrival+gallery+installation+pic.jpg.webp",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/0b2e0af2-6d72-475d-b7dd-31e9bfd66c81/Arrival+gallery+opening+night+9.jpg.webp",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/c8bf8a4f-cf23-42d4-8588-554c4cc23d48/Arrival+gallery+opening+night+2.jpg.webp",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/3ace1fba-4fe1-43b9-99ff-6270f7adfe90/Arrival+gallery+opening+night+12.jpg.webp",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/fd681ef5-f457-44b1-bdec-4d8fe66fcd64/IMG_6566.jpg",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/8123bcb6-5376-480c-9034-8848ee310fa3/IMG_2280.jpg",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/1c705597-6bcd-4d17-a764-bbfbb48f262d/IMG_2281.jpg",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/3d921174-f648-462f-9801-a3ce45f8fd76/IMG_2282.jpg",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/bea03a9b-edf6-4ca0-b98a-fb57a42d8e9b/IMG_2283.jpg",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/70903c1a-84b1-46b1-a25a-4a418cc5961a/IMG_5443+1.JPG",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/c68d21b4-64c2-4744-8a3d-4d6f254ad120/IMG_5535.JPG",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/6c1c0036-0019-4320-bf66-43dd956af3c1/Platform+Show+Orlando+Museum+of+Modern+Art.jpg",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/348aa0cc-586d-499a-b7cf-86569ba8cd7f/IMG_4939.PNG",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/51307dd9-7c08-45cd-8f72-dd0fc70aad58/24.png",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/ef10d208-a863-49a3-834c-16d0a5f17c8d/88C259E8-09B4-44E8-BB29-483B11C7D101.JPG",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/b292c10d-3aac-4964-b36a-735fe4cd8737/IMG_0739.PNG",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/717b6309-c82f-446f-abbc-57f32a3cd905/IMG_2587.jpg",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/6675a159-0cd1-4008-b189-b6ac26dfcb69/IMG_2588.jpg",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/22272c63-92a5-494e-bfe4-12caa81ca26f/IMG_2589.jpg",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/64ce44fe-113a-4241-988f-164f45259fb6/IMG_2590.jpg",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/b171354d-7a2a-4ab6-8688-ec4d40196562/IMG_2592.jpg",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/d77f4786-44a7-4719-a1d5-48aac07fd4cb/IMG_2593.jpg",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/bda92cbb-205e-4bd9-b4d5-4c93568fb0a5/IMG_2594.jpg",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/1a3636ec-df12-4659-b78a-f14196aa03a5/IMG_2595.jpg",
    "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/11807145-0154-4c43-b10f-1627a2ee1f04/IMG_3167.JPG"
  ];

  return (
    <div className="min-h-screen bg-off-black">
      <Navigation />

      {/* Content */}
      <div className="pt-24 sm:pt-28 md:pt-32 pb-16 sm:pb-24 md:pb-32 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          {/* Page Title */}
          <div className="mb-12 sm:mb-16 md:mb-24">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-soft-ivory tracking-tight mb-3 sm:mb-4">
              Exhibition Installations
            </h1>
            <div className="w-16 sm:w-20 h-1 bg-flesh-tone"></div>
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
            {installations.map((image, index) => (
              <div
                key={`installation-${index}-${image.substring(image.lastIndexOf('/') + 1, image.lastIndexOf('/') + 20)}`}
                className="group cursor-pointer"
              >
                <div className="overflow-hidden border border-zinc-800 hover:border-flesh-tone transition-colors duration-400 h-64 sm:h-72 md:h-80">
                  <img
                    src={image}
                    alt={`Exhibition installation ${index + 1}`}
                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default InstallationsPage;
